import { Alert } from "@mui/material";
import React from "react";

export type MemberInvoiceDeliveryFeedbackState = {
  severity: "success" | "info" | "warning" | "error";
  message: string;
};

export type MemberInvoiceDeliveryFeedbackProps = {
  feedback: MemberInvoiceDeliveryFeedbackState | null;
};

// Success is confirmed by the caller's success pop-up (one confirmation per
// action), so only info, warning, and error feedback renders inline.
const MemberInvoiceDeliveryFeedback = ({
  feedback,
}: MemberInvoiceDeliveryFeedbackProps) =>
  feedback && feedback.severity !== "success" ? (
    <Alert severity={feedback.severity} className="mb-4">
      {feedback.message}
    </Alert>
  ) : null;

export default MemberInvoiceDeliveryFeedback;
